// extracted by mini-css-extract-plugin
export default {"chip":"CategoryRiskLevel_chip__7bGMA","chip__root":"CategoryRiskLevel_chip__root__Qoti1 font-xs-regular"};